import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache: false
};

export default {
    path: '/businessReport',
    name: 'businessReport',
    redirect: {
        name: 'businessReport'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/businessReport/CoordinatedTransport',
            name: 'CoordinatedTransport',
            meta: {
                ...meta,
                title: '联程总指令',
                desc: '联程总指令'
            },
            component: () => import('@/pages/BusinessReportV0/0CoordinatedTransport/index.vue')
        },
        {
            path: '/businessReport/SectionCoordinatedTransport',
            name: 'SectionCoordinatedTransport',
            meta: {
                ...meta,
                title: '联程分段指令',
                desc: '联程分段指令'
            },
            component: () => import('@/pages/BusinessReportV0/0SectionCoordinatedTransport/index.vue')
        },
        {
            path: '/businessReport/InterlineBilEntry',
            name: 'InterlineBilEntry',
            meta: {
                ...meta,
                title: '联程费用录入',
                desc: '联程费用录入'
            },
            component: () => import('@/pages/BusinessReportV0/1InterTripExpenseEntry/index.vue')
        },
        {
            path: '/businessReport/InterlineBilEntryV1',
            name: 'InterlineBilEntryV1',
            meta: {
                ...meta,
                title: '联程费用录入',
                desc: '联程费用录入'
            },
            component: () => import('@/pages/BusinessReportV0/1InterTripExpenseEntryV2/index.vue')
        },
        {
            path: '/businessReport/InvoiceRequest',
            name: 'InvoiceRequest',
            meta: {
                ...meta,
                title: '收入发票申请',
                desc: '收入发票申请'
            },
            component: () => import('@/pages/BusinessReportV0/2RevenueInvoicingApplicationV1/index.vue')
        },
        {
            path: '/businessReport/InvoiceRequestV2',
            name: 'InvoiceRequestV2',
            meta: {
                ...meta,
                title: '收入发票申请',
                desc: '收入发票申请'
            },
            component: () => import('@/pages/BusinessReportV0/2RevenueInvoicingApplicationV2/index.vue')
        },
        {
            path: '/businessReport/BillReview',
            name: 'BillReview',
            meta: {
                ...meta,
                title: '账单审核',
                desc: '账单审核'
            },
            component: () => import('@/pages/BusinessReportV0/3BillReview/index.vue')
        },
        {
            path: '/businessReport/Invoicing',
            name: 'Invoicing',
            meta: {
                ...meta,
                title: '开票',
                desc: '开票'
            },
            component: () => import('@/pages/BusinessReportV0/4Invoicing/index.vue')
        },
        {
            path: '/businessReport/InvoiceQuery',
            name: 'InvoiceQuery',
            meta: {
                ...meta,
                title: '发票查询',
                desc: '发票查询'
            },
            component: () => import('@/pages/BusinessReportV0/5InvoiceQuery/index.vue')
        },

        {
            path: '/businessReport/InvoiceQuery/InvoiceVoiding',
            name: 'InvoiceVoiding',
            meta: {
                ...meta,
                title: '发票作废',
                desc: '发票查询'
            },
            component: () => import('@/pages/BusinessReportV0/5InvoiceQuery/InvoiceVoiding/index.vue')
        },
        {
            path: '/businessReport/InvoiceQuery/InvoiceOffset',
            name: 'InvoiceOffset',
            meta: {
                ...meta,
                title: '发票冲红',
                desc: '发票查询'
            },
            component: () => import('@/pages/BusinessReportV0/5InvoiceQuery/InvoiceOffset/index.vue')
        },

        {
            path: '/businessReport/UninvolvedQuery',
            name: 'UninvolvedQuery',
            meta: {
                ...meta,
                title: '未开发票查询',
                desc: '未开发票查询'
            },
            component: () => import('@/pages/BusinessReportV0/6UninvoicedQuery/index.vue')
        },
        {
            path: '/businessReport/CollectionWriteOff',
            name: 'CollectionWriteOff',
            meta: {
                ...meta,
                title: '收款核销',
                desc: '收款核销'
            },
            component: () => import('@/pages/BusinessReportV0/7CollectionWriteOff/index.vue')
        },
        {
            path: '/businessReport/SummaryOfAccountsReceivable',
            name: 'SummaryOfAccountsReceivable',
            meta: {
                ...meta,
                title: '应收账款汇总表',
                desc: '应收账款汇总表'
            },
            component: () => import('@/pages/BusinessReportV0/8SummaryOfAccountsReceivable/index.vue')
        },
        {
            path: '/businessReport/AdvanceCharge',
            name: 'AdvanceCharge',
            meta: {
                ...meta,
                title: '预付款',
                desc: '预付款'
            },
            component: () => import('@/pages/BusinessReportV0/9AdvanceCharge/index.vue')
        },
        {
            path: '/businessReport/CostPaymentApprovalProcess',
            name: 'CostPaymentApprovalProcess',
            meta: {
                ...meta,
                title: '成本支付审批流',
                desc: '成本支付审批流'
            },
            component: () => import('@/pages/BusinessReportV0/13CostPaymentApprovalProcess/index.vue')
        },
        {
            path: '/businessReport/CostPaymentApplication',
            name: 'CostPaymentApplication',
            meta: {
                ...meta,
                title: '成本支付申请',
                desc: '成本支付申请'
            },
            component: () => import('@/pages/BusinessReportV0/10CostPayment/index.vue')
        },
        {
            path: '/businessReport/CostApproval',
            name: 'CostApproval',
            meta: {
                ...meta,
                title: '成本审批',
                desc: '成本审批'
            },
            component: () => import('@/pages/BusinessReportV0/12CostApproval/index.vue')
        },
        {
            path: '/businessReport/CostPayment',
            name: 'CostPayment',
            meta: {
                ...meta,
                title: '成本付款',
                desc: '成本付款'
            },
            component: () => import('@/pages/BusinessReportV0/14CostPayment/index.vue')
        },
        {
            path: '/businessReport/CostQuery',
            name: 'CostQuery',
            meta: {
                ...meta,
                title: '成本查询',
                desc: '成本查询'
            },
            component: () => import('@/pages/BusinessReportV0/11CostQuery/index.vue')
        },
        {
            path: '/businessReport/CostPaymentDocument',
            name: 'CostPaymentDocument',
            meta: {
                ...meta,
                title: '成本付款单',
                desc: '成本付款单'
            },
            component: () => import('@/pages/BusinessReportV0/31CostPaymentDocument/index.vue')
        },
        {
            path: '/businessReport/InputInvoiceSummary',
            name: 'InputInvoiceSummary',
            meta: {
                ...meta,
                title: '进项发票汇总表',
                desc: '进项发票汇总表'
            },
            component: () => import('@/pages/BusinessReportV0/15InputInvoiceSummary/index.vue')
        },
        {
            path: '/businessReport/PurchaseContract',
            name: 'PurchaseContract',
            meta: {
                ...meta,
                title: '采购合同',
                desc: '采购合同'
            },
            component: () => import('@/pages/BusinessReportV0/16PurchaseContract/index.vue')
        },
        {
            path: '/businessReport/SalesContract',
            name: 'SalesContract',
            meta: {
                ...meta,
                title: '销售合同',
                desc: '销售合同'
            },
            component: () => import('@/pages/BusinessReportV0/17SalesContract/index.vue')
        },
        {
            path: '/businessReport/CustomerManagement',
            name: 'CustomerManagement',
            meta: {
                ...meta,
                title: '客户管理',
                desc: '客户管理'
            },
            component: () => import('@/pages/BusinessReportV0/18CustomerManagement/index.vue')
        },
        {
            path: '/businessReport/ProfitDetailsSummary',
            name: 'ProfitDetailsSummary',
            meta: {
                ...meta,
                title: '利润明细汇总表',
                desc: '利润明细汇总表'
            },
            component: () => import('@/pages/BusinessReportV0/19ProfitDetailsSummary/index.vue')
        },
        {
            path: '/businessReport/BusinessCategoryProfit',
            name: 'BusinessCategoryProfit ',
            meta: {
                ...meta,
                title: '业务类别',
                desc: '业务类别'
            },
            component: () => import('@/pages/BusinessReportV0/20BusinessCategoryProfit/index.vue')
        },
        {
            path: '/businessReport/BusinessCategoryMonthlyGrossProfit',
            name: 'BusinessCategoryMonthlyGrossProfit',
            meta: {
                ...meta,
                title: '业务类别月毛利统计表',
                desc: '业务类别月毛利统计表'
            },
            component: () => import('@/pages/BusinessReportV0/21BusinessCategoryMonthlyGrossProfit/index.vue')
        },
        {
            path: '/businessReport/BusinessCategoryMonthlyTrafficVolume',
            name: 'BusinessCategoryMonthlyTrafficVolume',
            meta: {
                ...meta,
                title: '业务类别月运量统计表',
                desc: '业务类别月运量统计表'
            },
            component: () => import('@/pages/BusinessReportV0/22BusinessCategoryMonthlyTrafficVolume/index.vue')
        },
        {
            path: '/businessReport/OwnerProfit',
            name: 'OwnerProfit',
            meta: {
                ...meta,
                title: '货主利润表',
                desc: '货主利润表'
            },
            component: () => import('@/pages/BusinessReportV0/23OwnerProfit/index.vue')
        },
        {
            path: '/businessReport/OwnersMonthlyTrafficVolume',
            name: 'OwnersMonthlyTrafficVolume',
            meta: {
                ...meta,
                title: '货主月运量统计表',
                desc: '货主月运量统计表'
            },
            component: () => import('@/pages/BusinessReportV0/24OwnersMonthlyTrafficVolume/index.vue')
        },
        {
            path: '/businessReport/OwnersMonthlyGrossProfit',
            name: 'OwnersMonthlyGrossProfit',
            meta: {
                ...meta,
                title: '货主月毛利统计表',
                desc: '货主月毛利统计表'
            },
            component: () => import('@/pages/BusinessReportV0/25OwnersMonthlyGrossProfit/index.vue')
        },
        {
            path: '/businessReport/GoodsProfit',
            name: 'GoodsProfit',
            meta: {
                ...meta,
                title: '货品利润表',
                desc: '货品利润表'
            },
            component: () => import('@/pages/BusinessReportV0/26GoodsProfit/index.vue')
        },
        {
            path: '/businessReport/GoodsMonthlyTrafficVolume',
            name: 'GoodsMonthlyTrafficVolume',
            meta: {
                ...meta,
                title: '货品月运量统计表',
                desc: '货品月运量统计表'
            },
            component: () => import('@/pages/BusinessReportV0/27GoodsMonthlyTrafficVolume/index.vue')
        },
        {
            path: '/businessReport/GoodsMonthlyGrossProfit',
            name: 'GoodsMonthlyGrossProfit',
            meta: {
                ...meta,
                title: '货品月毛利统计表',
                desc: '货品月毛利统计表'
            },
            component: () => import('@/pages/BusinessReportV0/28GoodsMonthlyGrossProfit/index.vue')
        },
        {
            path: '/businessReport/AnnualSchedule',
            name: 'AnnualSchedule',
            meta: {
                ...meta,
                title: '年度计划表',
                desc: '年度计划表'
            },
            component: () => import('@/pages/BusinessReportV0/29AnnualSchedule/index.vue')
        },
        {
            path: '/businessReport/DetailedList',
            name: 'DetailedList',
            meta: {
                ...meta,
                title: '详细明细清单',
                desc: '详细明细清单'
            },
            component: () => import('@/pages/BusinessReportV0/30DetailedList/index.vue')
        },

        {
            path: '/businessReport/BasicInformation/WorkUnitBasicInformation',
            name: 'WorkUnitBasicInformation',
            meta: {
                ...meta,
                title: '工作单位信息',
                desc: '工作单位信息'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/WorkUnitBasicInformation/index.vue')
        },

        {
            path: '/businessReport/BasicInformation/address_data',
            name: 'address_data',
            meta: {
                ...meta,
                title: '地址数据',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/address_data/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/billing_header_data',
            name: 'billing_header_data',
            meta: {
                ...meta,
                title: '开票抬头',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/billing_header_data/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/cargo_owner_data',
            name: 'cargo_owner_data',
            meta: {
                ...meta,
                title: '货主',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/cargo_owner_data/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/cost_items',
            name: 'cost_items',
            meta: {
                ...meta,
                title: '成本项目',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/cost_items/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/income_items',
            name: 'income_items',
            meta: {
                ...meta,
                title: '收入项目',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/income_items/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/payable_unit',
            name: 'payable_unit',
            meta: {
                ...meta,
                title: '应付单位',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/payable_unit/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/seagoing_ship',
            name: 'seagoing_ship',
            meta: {
                ...meta,
                title: '海船',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/seagoing_ship/index.vue')
        },
        {
            path: '/businessReport/BasicInformation/settlement_unit',
            name: 'settlement_unit',
            meta: {
                ...meta,
                title: '结算单位',
                desc: '基础数据维护'
            },
            component: () => import('@/pages/BusinessReportV0/32BasicInformation/basic_data_table/settlement_unit/index.vue')
        },

    ]
};
